export default "/assets/images/filter-OR.bfca4ecee00133c0.png";